import {
  GET_TEAM_EVENTS,
  GET_TEAM_ARCHIVE_EVENTS,
  GET_TEAM_PAST_EVENTS,
  GET_USER_EVENTS
} from 'actions/Types';

export default (state = true, action) => {
  if (
    [
      GET_TEAM_EVENTS,
      GET_TEAM_ARCHIVE_EVENTS,
      GET_USER_EVENTS,
      GET_TEAM_PAST_EVENTS,
      '@@router/LOCATION_CHANGE'
    ].includes(action.type)
  ) {
    return true;
  }

  if (
    action.type === `${GET_TEAM_EVENTS}_SUCCESS` ||
    action.type === `${GET_TEAM_ARCHIVE_EVENTS}_SUCCESS` ||
    action.type === `${GET_USER_EVENTS}_SUCCESS` ||
    action.type === `${GET_TEAM_EVENTS}_FAILURE` ||
    action.type === `${GET_TEAM_ARCHIVE_EVENTS}_FAILURE` ||
    action.type === `${GET_USER_EVENTS}_FAILURE` ||
    action.type === `${GET_TEAM_PAST_EVENTS}_SUCCESS` ||
    action.type === `${GET_TEAM_PAST_EVENTS}_FAILURE`
  ) {
    return false;
  }

  return state;
};
